<template>
    <div class="imc_load">
        <div id="files_added_imc" v-if="loaded_files.length > 0">
            <ul>
                <li class="file" v-for="file in loaded_files">
                    <input type="hidden" :value=file.id  name="jform[files][]">
                </li>
            </ul>
        </div>
        
        <file-pond
            name="imcfileloader"
            ref="pond"
            allow-multiple="true"
            :server=getConfig()
            label-idle="Додати файл (натисніть або перетяніть файл)"
            v-bind:files="myFiles"
            v-on:init="handleFilePondInit"
        />
    </div>
</template>

<script>
import  vueFilePond,{ setOptions  } from 'vue-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.min.css';


const  FilePond = vueFilePond(
    FilePondPluginFileValidateType,
   // FilePondPluginImagePreview ,
)

setOptions({
    labelFileProcessingComplete: 'Завантаження завершено',
    labelFileProcessing : 'Завантажуємо',
    labelTapToUndo : 'Натисніть щоб видалити',
    labelInvalidField :'Файл містить заборонений тип',
    imagePreviewMaxHeight : 100,
    allowImageTransform:false,
    imageTransformOutputStripImageHead: false,
    forceRevert:true,
    // imageCropAspectRatio: '1:1',
    
    //     imageResizeTargetWidth: 600,
    //    imageResizeTargetHeight: 600,
    //  styleLoadIndicatorPosition: 'center bottom',
    
});

export default {
    name: "imcloader",
    data: function () {
        return {
            myFiles: [],
            loaded_files : [],
            user_id: 0,
        }
    },
    
    props: {
        files : {
            type : Array,
            default: () => []
        },
        
        doc_id : {
            type: Number,
            default: -1,
        },
        
        doc_type : {
            type : String,
            required : true,
        },
        
        url_load: {
            type: String,
            default: '/files',
        },
        
        url_remove: {
            type: String,
            default: '/files',
        },
        
        trigger_load : {
            type: String,
            default: 'loader_load_file',
        },
        
        
        validate_geo : {
            type : Boolean,
            default : false,
        },
        enablePreview: {
            type: Boolean,
            default: false
        }
        
    },
    components: {
        FilePond: null, // Временно, переопределим в `created()`
    },
    
    created() {
       
        
        if(this.files.length  > 0) {
            for(let i = 0; i < this.files.length; i ++) {
                
                /*let site_path = this.files[i].site_path;
                let file = this.files[i];
                if(file.hasOwnProperty('is_api_path')) {
                    if (file.is_api_path) {
                        site_path = file.link;
                    }
                }*/
                
                let fl = {
                    source :  this.files[i].link,
                    options : {
                        type : "local",
                        
                    },
                    file: {
                        id : this.files[i].file_id,
                        name: this.files[i].name,
                        size: this.files[i].file_size,
                        type:this.files[i].mime
                    },
                }
                this.myFiles.push(fl);
            }
        }
        
        this.$options.components.FilePond = this.FilePondComponent;
    },
    computed: {
        token () {
            return getCookie('IMC_API');
        },
        
        FilePondComponent() {
            const plugins = [FilePondPluginFileValidateType];
            if (this.enablePreview) {
                plugins.push(FilePondPluginImagePreview);
            }
            return vueFilePond(...plugins);
        }
    },
    
    mounted() {
      /*  this.$options.components.FilePond.setOptions({
            labelFileProcessingComplete: 'Завантаження завершено',
            labelFileProcessing: 'Завантажуємо',
            labelTapToUndo: 'Натисніть щоб видалити',
            labelInvalidField: 'Файл містить заборонений тип',
            imagePreviewMaxHeight: 100,
            allowImageTransform: false,
            imageTransformOutputStripImageHead: false,
            forceRevert: true,
        });*/
    },
    methods: {
        handleFilePondInit() {
        
        },
        
        getConfig () {
            return {
                url: '/',
                timeout: 7000,
                
                process:(fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                    let self = this;
                    
                    // Создание FormData
                    const formData = new FormData();
                    formData.append(fieldName, file, file.name);
                    formData.append('doc_id', this.doc_id);
                    formData.append('doc_type', this.doc_type);
                    
                    // Конфигурация Axios
                    const config = {
                        headers: {
                            'Authorization': 'Bearer ' + self.token,
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        }
                    };
    
                    // Отправка запроса
                    api.post('https://api-zozenko.timc.biz/api/v1' + this.url_load, formData, config)
                        .then(response => {
                            let load_result = response.data;
                            console.warn('load_result:', load_result);
                            
                            if (load_result !== undefined) {
                                let status = load_result.status;
                                
                                if (status === 'operation_success') {
                                    let file = load_result.data;
                                    
                                    EventBus.$emit(self.trigger_load, {
                                        'type'      : 'file_loaded',
                                        'file_id'   : file.id,
                                        'doc_id'    : self.doc_id,
                                        'doc_type'  : self.doc_type,
                                        'full_file' : file,
                                    });
                                    
                                    self.loaded_files.push({
                                        id      : file.id,
                                        file    : file
                                    });
                                    load(file.id);
                                } else {
                                    error('IMC SRV Err');
                                    EventBus.$emit('show_toast', {
                                        err: load_result.message,
                                        type: "danger",
                                        title: 'Ошибка сохранения'
                                    });
                                }
                            } else {
                                error('oh no');
                                EventBus.$emit('show_toast', {
                                    err: 'Empty Response',
                                    type: "danger",
                                    title: 'Сервер ничего не вернул'
                                });
                            }
                        })
                        .catch(err => {
                            console.error('Error:', err);
                            error('oh no');
                            
                            try {
                                if(err.hasOwnProperty('response')) {
                                    let err_txt = err.response.data.message;
                                    EventBus.$emit('show_toast', {
                                        err: err_txt,
                                        type: "danger",
                                        title: 'Ошибка сохранения'
                                    });
                                }
                            }
                            catch (e) {
                                console.log('er_2',e);
                                EventBus.$emit('show_toast', {
                                    err: 'SRV err',
                                    type: "danger",
                                    title: 'Ошибка сохранения'
                                });
                            }
                         
                            
                        });
                    
                    // Возвращаем объект для возможности отмены запроса
                   /* return {
                        abort: () => {
                            console.log('abort');
                            // Axios не имеет прямого метода для отмены запроса,
                            // используйте CancelToken для этого
                            const source = axios.CancelToken.source();
                            source.cancel('Запрос был отменен пользователем.');
                            
                            // Сообщите FilePond, что запрос был отменен
                            abort();
                        }
                    };*/
                },
                
                remove: (source, load, error) => {
                    let self = this;
                    this.myFiles.map(item => {
                        if(item.source === source) {
                            self.remove_file_byid(item.file.id,'remove',res => {
                                if(res == null) {
                                    error('can remove');
                                } else {
                                    load();
                                }
                            },error);
                        }
                    });
                },
                
                revert : (uniqueFileId, load, error) => {
                    console.log('revert',uniqueFileId);
                    let self = this;
                    this.remove_file_byid(uniqueFileId,'revert',function(res){
                        if(res == null) {
                            error('can remove');
                        } else {
                            load();
                            self.clean_loaded_ul(uniqueFileId);
                        }
                    },error);
                },
                restore: null,
                load: (src, load, error) => {
                    fetch(src, {
                        method: "GET",
                        headers: {
                            "Authorization": 'Bearer ' + getCookie('IMC_API'),
                        }
                    })
                        .then(res => {
                            if (!res.ok) { // Проверяем статус ответа (4xx или 5xx)
                                throw new Error(`Error ${res.status}: ${res.statusText}`);
                            }
                            return res.blob();
                        })
                        
                        .then(load)
                        .catch(err => {
                            console.error("FilePond Load Error:", err);
                            error("Ошибка загрузки файла: " + err.message); // Вызываем FilePond error()
                        });
                },
                
                fetch: null
            }
        },
        
        clean_loaded_ul(id) {
            if(this.loaded_files.length > 0) {
                for (let j = this.loaded_files.length - 1; j >= 0; j -= 1) {
                    if(this.loaded_files[j].id === id) {
                        this.loaded_files.splice(j, 1);
                    }
                }
            }
        },
        
        async remove_file_byid(uniqueFileId,rem_type,callback,e_f) {
            console.log('removing.........', uniqueFileId);
            
            await api.delete( this.url_remove + '/' + uniqueFileId,{
                'remove_type' : rem_type
            }).then(({data}) => {
                let resp = data.data;
                if (data.status === "operation_success") {
                    EventBus.$emit(this.trigger_load,{
                        'type'      : 'file_deleted',
                        'file_id'   : uniqueFileId,
                        'doc_id'    : this.doc_id,
                        'doc_type'  : this.doc_type,
                    });
                    callback(data);
                }
                
                else {
                    e_f('oops');
                    callback(null);
                }
            }).catch(err => {
                if(e_f != undefined) {
                    e_f('oops');
                    callback(null);
                }
                
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.status})
                console.log(err);
            });
        },
    },
    
}
</script>

<style scoped>
#files_added_imc {
    display: none;
}
</style>
